import React from 'react';

const CircularProgress = ({ percentage, strokeColor, icon, value, label }) => {
  const radius = 54;
  const strokeWidth = 8;
  const circumference = 2 * Math.PI * radius;
  const progressOffset = circumference - (percentage / 100) * circumference;

  const containerStyle = {
    position: "relative",
    width: "120px",
    height: "120px",
  };

  const centerTextStyle = {
    width: "75%",
    height: "75%",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    backgroundColor: "#F7FAFC",
    borderRadius: "50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };

  return (
    <div style={containerStyle}>
      <svg width="120" height="120" viewBox="0 0 120 120">
        <circle
          cx="60"
          cy="60"
          r={radius}
          stroke="#EDF2F7"
          strokeWidth={strokeWidth}
          fill="none"
        />
        <circle
          cx="60"
          cy="60"
          r={radius}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={progressOffset}
          transform="rotate(-90 60 60)"
          strokeLinecap="round"
        />
      </svg>
      <div style={centerTextStyle}>
        <div className='d-flex justify-content-center'>
          <img src={icon} alt="" width={16} height={16} />
        </div>
        <div style={{ fontSize: "24px", fontWeight: "bold", fontFamily: `"inter", sans-serif`, textAlign: 'center' }}>
          {value.toFixed(0)}
        </div>
        <div style={{
          fontSize: "8px", fontWeight: '700', color: "#1A1E23",
          lineHeight: '100%', fontFamily: `"inter", sans-serif`
        }}>
          {label}
        </div>
      </div>
    </div>
  );
};

export default CircularProgress;
